/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 ScetchFabPepe.glb -t -k -m -s -D 
*/

import * as THREE from "three";
import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { useFrame } from "@react-three/fiber";

type GLTFResult = GLTF & {
  nodes: {
    model_2001: THREE.SkinnedMesh;
    model_2002: THREE.SkinnedMesh;
    mixamorigHips: THREE.Bone;
  };
  materials: {
    ["DefaultMaterial.005"]: THREE.MeshStandardMaterial;
  };
  animations: GLTFAction[];
};

type ActionName =
  | "Armature.001|Armature|Armature|mixamo.com|Layer0"
  | "Armature.001|mixamo.com|Layer0"
  | "Armature.002|Armature|Armature|mixamo.com|Layer0"
  | "Armature.002|Armature|Armature|mixamo.com|Layer0.001"
  | "Armature.002|Armature|Armature|mixamo.com|Layer0.002"
  | "Armature.002|mixamo.com|Layer0"
  | "Armature.003|Armature|Armature|mixamo.com|Layer0"
  | "Armature.003|mixamo.com|Layer0"
  | "Armature.004|Armature|Armature|mixamo.com|Layer0"
  | "Armature.004|mixamo.com|Layer0"
  | "Armature.005|Armature|Armature|mixamo.com|Layer0"
  | "Armature.005|Armature|Armature|mixamo.com|Layer0.002"
  | "Armature.005|mixamo.com|Layer0"
  | "Armature|mixamo.com|Layer0"
  | "Armature|mixamo.com|Layer0.001"
  | "Armature|mixamo.com|Layer0.002";
interface GLTFAction extends THREE.AnimationClip {
  name: ActionName;
}
type ContextType = Record<
  string,
  React.ForwardRefExoticComponent<
    JSX.IntrinsicElements["skinnedMesh"] | JSX.IntrinsicElements["bone"]
  >
>;

export function Pepe(props: JSX.IntrinsicElements["group"]) {
  const group = useRef<THREE.Group>(null!);
  const { nodes, materials, animations } = useGLTF(
    "/assets/models/Pepe.glb"
  ) as GLTFResult;
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    actions?.["Armature.003|mixamo.com|Layer0"]?.play();
  });

  useFrame((state) => {
    const t = state.clock.getElapsedTime();

    group.current.rotation.y = t * 0.3;
  });

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group
          name="Armature"
          rotation={[Math.PI / 2, 0, 0]}
          scale={0.01}
          userData={{ name: "Armature" }}
        >
          <primitive object={nodes.mixamorigHips} />
          <skinnedMesh
            name="model_2001"
            geometry={nodes.model_2001.geometry}
            material={materials["DefaultMaterial.005"]}
            skeleton={nodes.model_2001.skeleton}
            userData={{ name: "model_2.001" }}
          />
          <skinnedMesh
            name="model_2002"
            geometry={nodes.model_2002.geometry}
            material={materials["DefaultMaterial.005"]}
            skeleton={nodes.model_2002.skeleton}
            userData={{ name: "model_2.002" }}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/assets/models/Pepe.glb");
